var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgNewcsDashboardLeftArrow = function SvgNewcsDashboardLeftArrow(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 6,
    height: 10
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "newcs_dashboard_left_arrow_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M528 107h6v10h-6z"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#newcs_dashboard_left_arrow_svg__a)",
    transform: "translate(-528 -107)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M533.997 112a.7.7 0 0 1-.22.505l-4.5 4.285a.776.776 0 0 1-1.061 0 .69.69 0 0 1 0-1.011l3.967-3.78-3.967-3.78a.69.69 0 0 1 0-1.011.776.776 0 0 1 1.061 0l4.5 4.285a.7.7 0 0 1 .22.507"
  }))));
};
export default SvgNewcsDashboardLeftArrow;